import { createApp } from 'vue';
import { mountReplace } from '../utils/mountUtils';
import ImageCardGrid, { type ImageCardGridProps } from '@lmt-rpb/Molecules/ImageCardGrid/ImageCardGrid.vue';
import { parseJson } from 'src/utils/json';

const mountPoint = document.querySelector<HTMLElement>('.image-cards-typo3');

function initImageCardsPlugin() {
	const dataset = mountPoint?.dataset;
	const layout = dataset?.layout || 'small';
	const imageCards = parseJson<ImageCardGridProps['imageCards']>(dataset?.imageCards, []);
	const promotionNotice = parseJson<Record<string, unknown> | null>(dataset?.actionNotice, null);
	if (!imageCards?.length && !promotionNotice) return;
	const app = createApp(ImageCardGrid, {
		imageCards: imageCards,
		promotionNotice: promotionNotice,
		layout,
	});
	if (mountPoint) mountReplace(app, mountPoint);
}

if (mountPoint) {
	initImageCardsPlugin();
}
